import styled, { createGlobalStyle } from "styled-components";

export const HelperStyle = createGlobalStyle`
    *,
    ::after,
    ::before
    {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    } 
    ul
    {
        list-style-type: none;
    }
    a
    {
        text-decoration: none;
    }
`;

export const ContainerSignature = styled.div`
    grid-area: main;
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
`;

export const MainContainerSignature = styled.div`
    padding: 40px 55px;
`;